var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1651 0.00136075C16.0969 -0.00566192 16.0282 -0.00566192 15.9601 0.00136075H1.96007C1.87034 0.00274331 1.78121 0.0161974 1.69507 0.0413607L8.92007 7.23636L16.1651 0.00136075Z",
    fill: "#939393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9051 0.695312L9.62509 7.94531C9.43773 8.13156 9.18427 8.23611 8.92009 8.23611C8.6559 8.23611 8.40245 8.13156 8.21509 7.94531L1.00009 0.750313C0.977908 0.831833 0.966147 0.915835 0.965088 1.00031V11.0003C0.965088 11.2655 1.07044 11.5199 1.25798 11.7074C1.44552 11.895 1.69987 12.0003 1.96509 12.0003H15.9651C16.2303 12.0003 16.4847 11.895 16.6722 11.7074C16.8597 11.5199 16.9651 11.2655 16.9651 11.0003V1.00031C16.9611 0.89614 16.9409 0.79323 16.9051 0.695312ZM2.65009 11.0003H1.95509V10.2853L5.59009 6.68031L6.29509 7.38531L2.65009 11.0003ZM15.9551 11.0003H15.2551L11.6101 7.38531L12.3151 6.68031L15.9501 10.2853L15.9551 11.0003Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.59c40f1bc786fe358507e5b3763e1bd7.svg";
export { ForwardRef as ReactComponent };